import {
  CHANGE_STEP,
  SET_COMPLETE_STEP,
  SHOW_APPROVE,
  RECEIVE_USER_DATA,
  RECEIVE_EXAM_DATA,
  REQUEST_APPEAL_SUCCESS,
  REQUEST_APPEAL_ERROR,
  NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR,
  REQUEST_APPEAL_ALREADY_REPORTED
} from '../constants';

import { START_STEP, STEP1, STEP2 } from '../../constants/steps';

const stepInitialState = {
  id: START_STEP,
  success: false,
  complete: {},
  confirmation: false,
  error: false
};

const step = (state = stepInitialState, action) => {
  switch (action.type) {
    case NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR:
      return {
        ...stepInitialState
      };
    case RECEIVE_USER_DATA:
      return {
        ...state,
        id: STEP1
      };
    case RECEIVE_EXAM_DATA:
      return {
        ...state,
        id: STEP2
      };
    case CHANGE_STEP:
      return {
        ...state,
        id: action.payload
      };
    case SET_COMPLETE_STEP: {
      const { stepId, isComplete } = action.payload;
      return {
        ...state,
        complete: {
          ...state.complete,
          [stepId]: isComplete
        }
      };
    }
    case SHOW_APPROVE:
      return {
        ...state,
        confirmation: !action.payload
      };
    case REQUEST_APPEAL_SUCCESS:
      return {
        ...state,
        complete: {},
        confirmation: false
      };
    case REQUEST_APPEAL_ERROR:
    case REQUEST_APPEAL_ALREADY_REPORTED:
      return {
        ...state,
        confirmation: false
      };
    default:
      return state;
  }
};

export default step;
